import { useQuery } from "@tanstack/react-query";
import { fetchRedemptionProducts } from "@/api/redemption";

/**
 * The campaign's gift set for the recipient feed, resolved from the gift-link
 * token. Keyed by token (the credential on the public /g/:token route) — the set
 * is campaign-scoped, so there's no collection id in the key.
 */
export function useRedemptionProducts(token: string | undefined) {
  return useQuery({
    queryKey: ["redemption", "products", token],
    queryFn: () => {
      if (!token) throw new Error("Missing gift token");
      return fetchRedemptionProducts(token);
    },
    enabled: !!token,
  });
}
